import { render, staticRenderFns } from "./data.vue?vue&type=template&id=fa732d5a&scoped=true&"
import script from "./data.vue?vue&type=script&lang=js&"
export * from "./data.vue?vue&type=script&lang=js&"
import style0 from "./data.vue?vue&type=style&index=0&id=fa732d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa732d5a",
  null
  
)

export default component.exports